import { useBrand } from '../context/BrandContext'

export function useBrandColors() {
  const { brand } = useBrand()
  const accent = brand.primaryColor || '#B8734A'
  const accentLight = accent + '22'
  const accentBg = accent + '15'
  const sidebar = brand.sidebarColor || '#2B2B2B'
  const bg = brand.bgColor || '#F7F2EB'
  const text = brand.textColor || '#2B2B2B'
  return { accent, accentLight, accentBg, sidebar, bg, text }
}